import Inventory2Icon from "@mui/icons-material/Inventory2";
import PeopleIcon from "@mui/icons-material/People";
import SettingsIcon from "@mui/icons-material/Settings";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import {
  AppBar,
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import {
  LoadingIndicator,
  Logout,
  usePermissions,
  useTranslate,
  useUserMenu,
} from "react-admin";
import { Link, matchPath, useLocation } from "react-router-dom";
import { useConfigurationContext } from "../root/ConfigurationContext";
import AppsMenu from "../Componentes/AppsMenu";
import NotificationsMenu from "./NotificationsMenu";
import ScmUserMenu from "./ScmUserMenu";

const Header = () => {
  const { logo, title } = useConfigurationContext();
  const location = useLocation();
  const { permissions } = usePermissions();

  let currentPath: string | boolean = "/";
  if (!!matchPath("/", location.pathname)) {
    currentPath = "/";
  } else if (!!matchPath("/suppliercontacts/*", location.pathname)) {
    currentPath = "/suppliercontacts";
  } else if (!!matchPath("/suppliers/*", location.pathname)) {
    currentPath = "/suppliers";
  } else if (!!matchPath("/purchaseorders/*", location.pathname)) {
    currentPath = "/purchaseorders";
  } else if (!!matchPath("/scmskus/*", location.pathname)) {
    currentPath = "/scmskus";
  } else if (!!matchPath("/skurankings/*", location.pathname)) {
    currentPath = "/skurankings";
  } else if (!!matchPath("/scmanalyses/*", location.pathname)) {
    currentPath = "/scmanalyses";
  } else {
    currentPath = false;
  }

  return (
    <Box component="nav" sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="primary">
        <Toolbar variant="dense">
          <Box flex={1} display="flex" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              component={Link}
              to="/"
              sx={{
                color: "inherit",
                textDecoration: "inherit",
              }}
              gap={1.5}
            >
              <Box component="img" sx={{ height: 24 }} src={logo} alt={title} />
              <Typography component="span" variant="h5">
                {title}
              </Typography>
            </Box>
            <Box>
              <Tabs
                value={currentPath}
                aria-label="Navigation Tabs"
                indicatorColor="secondary"
                textColor="inherit"
              >
                <Tab label={"Painel"} component={Link} to="/" value="/" />
                <Tab
                  label={"Contatos"}
                  component={Link}
                  to="/suppliercontacts"
                  value="/suppliercontacts"
                />
                <Tab
                  label={"Fornecedores"}
                  component={Link}
                  to="/suppliers"
                  value="/suppliers"
                />
                <Tab
                  label={"SKUS"}
                  component={Link}
                  to="/scmskus"
                  value="/scmskus"
                />
                {/* TODO: Voltar a exibir "RANKINGS" aqui na próxima semana. */}
                <Tab
                  label={"ANÁLISES"}
                  component={Link}
                  to="/scmanalyses"
                  value="/scmanalyses"
                />
                <Tab
                  label={"ORDENS DE COMPRA"}
                  component={Link}
                  to="/purchaseorders"
                  value="/purchaseorders"
                />
              </Tabs>
            </Box>
            <Box display="flex" alignItems="center">
              <NotificationsMenu />
              <AppsMenu />
              <LoadingIndicator />
              <ScmUserMenu>
                <ConfigurationMenu />
                {permissions === "admin" && <UsersMenu />}
                <SkucmmsMenu />
                {permissions === "admin" && <ScmConfigsMenu />}
                <SkuRankingsMenu />
                <Logout />
              </ScmUserMenu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

const UsersMenu = () => {
  const { onClose } = useUserMenu() ?? {};
  return (
    <MenuItem component={Link} to="/buyers" onClick={onClose}>
      <ListItemIcon>
        <PeopleIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Compradores</ListItemText>
    </MenuItem>
  );
};

const SkucmmsMenu = () => {
  const translate = useTranslate();
  const { onClose } = useUserMenu() ?? {};
  return (
    <MenuItem component={Link} to="/skucmms" onClick={onClose}>
      <ListItemIcon>
        <Inventory2Icon fontSize="small" />
      </ListItemIcon>
      <ListItemText>{translate("menu.skucmms")}</ListItemText>
    </MenuItem>
  );
};

const SkuRankingsMenu = () => {
  const { onClose } = useUserMenu() ?? {};
  return (
    <MenuItem component={Link} to="/skurankings" onClick={onClose}>
      <ListItemIcon>
        <AnalyticsIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Rankings</ListItemText>
    </MenuItem>
  );
};

const ScmConfigsMenu = () => {
  const { onClose } = useUserMenu() ?? {};
  return (
    <MenuItem component={Link} to="/scmconfigs" onClick={onClose}>
      <ListItemIcon>
        <RoomPreferencesIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Configuração</ListItemText>
    </MenuItem>
  );
};

const ConfigurationMenu = () => {
  const { onClose } = useUserMenu() ?? {};
  return (
    <MenuItem component={Link} to="/profiles" onClick={onClose}>
      <ListItemIcon>
        <SettingsIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Meus dados</ListItemText>
    </MenuItem>
  );
};
export default Header;
